import React from 'react'
import Modal from '../../../../common/modal/Modal'
import MicroModal from "micromodal"
import UserStats from './content/UserStats'
import { useUserReport } from '../../ReportingGroup/context/UserReportContext'
import EnrolledCourses from '../../ReportingGroup/UserReport/EnrolledCourses'

const UserCourseList = ({ courses }) => {
    MicroModal.init()

    const { selectedUser } = useUserReport()

    return (
        <Modal 
            modalId={`msync-report-user-course-list`} 
            buttonTitle={''} 
            modalHeading={'User Details'}
            classNames={''} 
            containerClassNames={'msync-report-user-container'}
        >
            <main className="msync-modal__body msync-modal__body--has-table msync-reporting__detail" key={selectedUser.user_id}>
              { selectedUser && (
                <>
                    <UserStats /> 
                    <EnrolledCourses courses={courses} />
                </>
              ) }
            </main>
        </Modal>
    )
}

export default UserCourseList